import React from 'react';

import block from 'propmods';

import { MenuItem } from '../../model/menu-item';
import Link from '../Link/Link';

import './Menu.scss';

interface MenuProps {
    items: MenuItem[];
    disabled?: boolean;
}

const b = block('Menu');

export default function Menu(props: MenuProps) {
    return (
        <ul {...b(props)}>
            {props.items.map((item) => (
                <li {...b('item')} key={item.path}>
                    <Link
                        to={item.path}
                        exact={item.exact}
                        onClick={props.disabled ? (e) => e.preventDefault() : undefined}
                        tabIndex={props.disabled ? -1 : undefined}
                        aria-disabled={props.disabled || undefined}
                    >
                        {item.title}
                    </Link>
                </li>
            ))}
        </ul>
    );
}
